<template>
  <div class="pk-case-upgrade-page pk-account-panel">
    <section class="pk-case-upgrade-shell">
      <header class="pk-case-upgrade-title">
        <div class="pk-title-left">
          <span class="pk-title-icon"></span>
          <h1>箱子升级</h1>
          <button @click="notify">怎么玩?</button>
        </div>
      </header>

      <section class="pk-upgrade-stage">
        <div class="pk-stage-side pk-stage-side--left">
          <img class="pk-ghost-weapon" :src="weaponGhost" alt="" />
          <div class="pk-side-copy">
            <strong>选择您的物品</strong>
            <span></span>
          </div>
          <p>所选物品: 0/20</p>
          <div class="pk-side-switch">
            <button :class="{ active: sourceMode === 'items' }" @click="sourceMode = 'items'">物品</button>
            <button :class="{ active: sourceMode === 'pizza' }" @click="sourceMode = 'pizza'">比萨</button>
          </div>
          <small>滚动范围: 0 - 0</small>
        </div>

        <div class="pk-stage-core">
          <div class="pk-price-tag pk-price-tag--left">
            <span>总价格</span>
            <strong>0.00<i></i></strong>
          </div>
          <div class="pk-chance-orbit" :class="{ previewing: isPreviewing }">
            <span class="pk-orbit-pointer"></span>
            <div class="pk-chance-ring">
              <strong>0%</strong>
            </div>
          </div>
          <div class="pk-price-tag pk-price-tag--right">
            <span>箱子价格</span>
            <strong>0.00<i></i></strong>
          </div>
        </div>

        <div class="pk-stage-side pk-stage-side--right">
          <img v-if="!caseLoading && cases.length" class="pk-ghost-weapon" :src="selectedCase.img" alt="" @error="useCaseFallback($event, selectedCase.fallback)" />
          <div class="pk-side-copy">
            <strong>选择箱子</strong>
            <span></span>
          </div>
          <button class="pk-upgrade-action" :class="{ previewing: isPreviewing }" :disabled="isPreviewing" @click="previewUpgrade">{{ isPreviewing ? '预览中...' : '升级预览' }}</button>
        </div>
      </section>

      <section class="pk-upgrade-settings">
        <div class="pk-comfort-figure pk-comfort-figure--good" :style="{ backgroundImage: `url(${comfortScene})` }" aria-hidden="true"></div>
        <div class="pk-upgrade-controls">
          <div class="pk-roll-mode">
            <button :class="{ active: rollDirection === 'down' }" @click="rollDirection = 'down'">往下滚 <b>↓</b></button>
            <button :class="{ active: rollDirection === 'up' }" @click="rollDirection = 'up'">往上滚 <b>↑</b></button>
          </div>
          <div class="pk-multiply-line">
            <span>获胜<br />机会<br />0%</span>
            <button v-for="item in multipliers" :key="item" :class="{ active: item === multiplier }" @click="setMultiplier(item)">
              {{ item }}
            </button>
            <span>乘数<br />{{ multiplier }}</span>
          </div>
          <div class="pk-balance-line">
            <span>使用<br />余额</span>
            <div class="pk-slider"><i></i></div>
            <i class="pk-token"></i>
            <strong>0</strong>
          </div>
        </div>
        <div class="pk-comfort-figure pk-comfort-figure--bad" :style="{ backgroundImage: `url(${comfortScene})` }" aria-hidden="true"></div>
      </section>

      <section class="pk-upgrade-lists">
        <div class="pk-inventory-column">
          <header>
            <h2>您的物品</h2>
            <button>价格 ↑</button>
          </header>
          <div class="pk-empty-inventory"></div>
        </div>

        <div class="pk-target-column">
          <header>
            <h2>升级</h2>
            <div class="pk-target-tools">
              <label>
                <span></span>
                <input value="搜索箱子" readonly />
              </label>
              <button><i></i>价格</button>
              <button>价格 ↑</button>
            </div>
          </header>
          <div v-if="caseLoading" class="pk-upgrade-case-state">正在读取可升级目标箱子</div>
          <div v-else-if="!cases.length" class="pk-upgrade-case-state">暂无可升级目标箱子</div>
          <div v-else class="pk-target-grid">
            <article v-for="item in cases" :key="item.name" :class="{ active: item.name === selectedCase.name }" class="pk-target-card" @click="selectCase(item)">
              <em>{{ item.badge }}</em>
              <div class="pk-card-visual">
                <img :src="item.img" alt="" @error="useCaseFallback($event, item.fallback)" />
              </div>
              <strong>{{ item.name }}</strong>
              <span>{{ item.price }}<i></i></span>
            </article>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  name: "CaseUpgrade",
  data() {
    const casePurple = require("../assets/hotpizza/hp-case-purple-transparent.png");
    const akGreen = require("../assets/hotpizza/hp-ak-green.png");
    const comfortScene = require("../assets/hotpizza/hp-case-upgrade-comfort-reference.png");
    return {
      multiplier: "1.2X",
      sourceMode: "items",
      rollDirection: "down",
      isPreviewing: false,
      selectedCaseName: "",
      weaponGhost: akGreen,
      caseFallback: casePurple,
      caseFallbacks: [
        casePurple,
        require("../assets/hotpizza/hp-case-crystal.png"),
        require("../assets/hotpizza/hp-case-orange.png"),
        require("../assets/hotpizza/hp-case-green.png"),
        require("../assets/hotpizza/hp-case-blue.png"),
        require("../assets/hotpizza/hp-case-ice.png"),
        require("../assets/hotpizza/hp-case-fire.png"),
      ],
      caseLoading: true,
      comfortScene,
      multipliers: ["1X", "1.2X", "2X", "5X"],
      cases: [],
    };
  },
  methods: {
    selectCase(item) {
      this.selectedCaseName = item.name;
    },
    setMultiplier(item) {
      this.multiplier = item;
    },
    notify() {
      this.$message({
        message: "箱子升级暂未开放。",
        type: "info",
      });
    },
    previewUpgrade() {
      this.isPreviewing = true;
      window.setTimeout(() => {
        this.isPreviewing = false;
        this.$message({
          message: "动画预览完成。",
          type: "info",
        });
      }, 1800);
    },
    normalizeAssetUrl(url) {
      return String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
    },
    caseImageUrl(url, fallback) {
      const image = this.normalizeAssetUrl(url);
      return image.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1 ? fallback : image || fallback;
    },
    useCaseFallback(event, fallback) {
      event.target.onerror = null;
      event.target.src = fallback || this.caseFallback;
    },
    loadCases() {
      this.$axios.post("/index/Box/boxList", this.$qs.stringify({ page: 1, pageSize: 24 })).then((res) => {
        const groups = res.data.status == 1 && res.data.data ? res.data.data.list || [] : [];
        this.cases = groups
          .reduce((list, group) => list.concat(group.box_list || []), [])
          .slice(0, 24)
          .map((item, index) => ({
            id: item.id,
            name: item.name,
            price: item.price,
            badge: "",
            fallback: this.caseFallbacks[index % this.caseFallbacks.length],
            img: this.caseImageUrl(item.img_active || item.img_main, this.caseFallbacks[index % this.caseFallbacks.length]),
          }));
        this.selectedCaseName = this.cases.length ? this.cases[0].name : "";
        this.caseLoading = false;
      }).catch(() => {
        this.cases = [];
        this.selectedCaseName = "";
        this.caseLoading = false;
      });
    },
  },
  computed: {
    selectedCase() {
      return this.cases.find((item) => item.name === this.selectedCaseName) || this.cases[0] || { img: this.caseFallback, fallback: this.caseFallback };
    },
  },
  mounted() {
    this.loadCases();
  },
};
</script>

<style lang="less" scoped>
.pk-case-upgrade-page {
  min-height: calc(100vh - 198px);
  padding: 0 0 90px;
  color: #f2f4ff;
  background: #1f212c;
}

button,
input {
  font-family: inherit;
}

button {
  cursor: pointer;
}

.pk-case-upgrade-shell {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  padding: 0 28px 0;
}

.pk-case-upgrade-title {
  height: 92px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.075);
}

.pk-title-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.pk-title-icon {
  width: 32px;
  height: 32px;
  display: block;
  position: relative;
  border: 3px solid #f4f6ff;
  border-radius: 50%;
}

.pk-title-icon::before,
.pk-title-icon::after {
  content: "";
  position: absolute;
  left: 7px;
  right: 7px;
  height: 6px;
  border-radius: 8px;
  background: #f4f6ff;
}

.pk-title-icon::before {
  top: 7px;
}

.pk-title-icon::after {
  bottom: 7px;
}

.pk-case-upgrade-title h1 {
  margin: 0;
  color: #f4f6ff;
  font-size: 24px;
  line-height: 1;
  font-weight: 1000;
}

.pk-case-upgrade-title button {
  width: 76px;
  height: 42px;
  color: #f4f6ff;
  background: #272c3b;
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 1000;
}

.pk-upgrade-stage {
  min-height: 320px;
  margin-top: 48px;
  display: grid;
  grid-template-columns: minmax(230px, 1fr) 420px minmax(230px, 1fr);
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  background:
    radial-gradient(circle at 50% 45%, rgba(67, 88, 255, 0.25), transparent 24%),
    linear-gradient(90deg, #171a25 0%, #1f2231 32%, #1f2231 68%, #171a25 100%);
}

.pk-upgrade-stage::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 122px;
  background: linear-gradient(180deg, rgba(31, 33, 44, 0), rgba(15, 17, 25, 0.56));
  pointer-events: none;
}

.pk-stage-side {
  min-width: 0;
  min-height: 320px;
  height: 320px;
  box-sizing: border-box;
  padding: 42px 34px 20px;
  display: grid;
  align-content: end;
  justify-items: center;
  position: relative;
  text-align: center;
}

.pk-stage-side--left {
  padding-left: 46px;
}

.pk-stage-side--right {
  padding-right: 46px;
}

.pk-stage-side--left::after,
.pk-stage-side--right::after {
  content: "";
  width: 60px;
  height: 430px;
  position: absolute;
  top: -28px;
  border-right: 4px solid #ffd46a;
  transform: rotate(-15deg);
  filter: drop-shadow(0 0 10px rgba(255, 204, 74, 0.16));
}

.pk-stage-side--left::after {
  right: -8px;
}

.pk-stage-side--right::after {
  left: -8px;
  transform: rotate(15deg) scaleX(-1);
}

.pk-ghost-weapon {
  width: 170px;
  height: 100px;
  position: absolute;
  top: 78px;
  object-fit: contain;
  opacity: 0.16;
  filter: grayscale(1) brightness(0.72);
}

.pk-side-copy {
  color: #ffd664;
  font-size: 18px;
  font-weight: 1000;
}

.pk-side-copy span {
  width: 26px;
  height: 30px;
  margin: 14px auto 0;
  display: block;
  position: relative;
}

.pk-side-copy span::before,
.pk-side-copy span::after {
  content: "";
  width: 16px;
  height: 16px;
  position: absolute;
  left: 5px;
  border-right: 3px solid #ffc84c;
  border-bottom: 3px solid #ffc84c;
  transform: rotate(45deg);
}

.pk-side-copy span::before {
  top: 0;
}

.pk-side-copy span::after {
  top: 12px;
}

.pk-stage-side p {
  margin: 19px 0 8px;
  color: #878d9e;
  font-size: 14px;
  font-weight: 800;
}

.pk-side-switch {
  width: 210px;
  height: 48px;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #2c303b;
  border-radius: 26px;
}

.pk-side-switch button {
  color: #f4f6ff;
  background: transparent;
  border: 0;
  border-radius: 26px;
  font-size: 16px;
  font-weight: 1000;
}

.pk-side-switch .active {
  background: #343845;
}

.pk-stage-side small {
  margin-top: 13px;
  color: #646b7e;
  font-size: 12px;
  font-weight: 800;
}

.pk-upgrade-action {
  width: 230px;
  height: 62px;
  margin-top: 28px;
  color: #fff;
  background: #999998;
  border: 0;
  border-radius: 4px;
  font-size: 26px;
  font-weight: 1000;
}

.pk-upgrade-action.previewing {
  cursor: wait;
  filter: brightness(1.16);
}

.pk-stage-core {
  min-width: 0;
  display: grid;
  place-items: center;
  position: relative;
  z-index: 2;
}

.pk-chance-orbit {
  width: 260px;
  height: 260px;
  display: grid;
  place-items: center;
  position: relative;
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(70, 89, 183, 0.28) 0 42%, rgba(50, 65, 173, 0.82) 43% 56%, rgba(38, 54, 152, 0.9) 57% 67%, transparent 68%);
  box-shadow: 0 0 70px rgba(80, 98, 255, 0.38);
}

.pk-chance-orbit.previewing {
  animation: pk-case-upgrade-preview 1.8s cubic-bezier(0.2, 0.75, 0.2, 1) both;
}

@keyframes pk-case-upgrade-preview {
  from { transform: rotate(0deg) scale(1); }
  72% { transform: rotate(715deg) scale(1.035); }
  to { transform: rotate(720deg) scale(1); }
}

.pk-orbit-pointer {
  width: 0;
  height: 0;
  position: absolute;
  top: 46px;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 15px solid #f5c858;
  z-index: 3;
}

.pk-chance-ring {
  width: 164px;
  height: 164px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background:
    radial-gradient(circle, #30364d 0 54%, transparent 55%),
    conic-gradient(#4e5fb7 0 100%);
  box-shadow:
    inset 0 0 0 16px rgba(141, 151, 211, 0.2),
    inset 0 0 36px rgba(12, 17, 34, 0.58);
}

.pk-chance-ring strong {
  color: #e9ecf4;
  font-size: 38px;
  line-height: 1;
  font-weight: 1000;
}

.pk-price-tag {
  width: 118px;
  height: 66px;
  padding-top: 10px;
  display: grid;
  place-items: center;
  position: absolute;
  bottom: 25px;
  z-index: 4;
  color: #1f212c;
  background: #ffcf62;
  clip-path: polygon(13% 0, 100% 0, 88% 100%, 0 100%);
  font-weight: 1000;
}

.pk-price-tag--left {
  left: -8px;
}

.pk-price-tag--right {
  right: -8px;
}

.pk-price-tag span {
  font-size: 16px;
}

.pk-price-tag strong {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #474156;
  font-size: 20px;
}

.pk-token,
.pk-price-tag i,
.pk-target-card i,
.pk-target-tools i {
  width: 14px;
  height: 14px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-upgrade-controls {
  min-height: 306px;
  height: 306px;
  box-sizing: border-box;
  margin: 14px 94px 0;
  padding: 56px 0 0;
  border-radius: 18px 18px 0 0;
  background:
    radial-gradient(circle at 50% 0, rgba(65, 84, 184, 0.2), transparent 42%),
    linear-gradient(180deg, #181b27, #171923);
  border-top: 1px solid rgba(255, 255, 255, 0.035);
}

.pk-roll-mode {
  width: 276px;
  height: 33px;
  margin: 0 auto 38px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #626a7c;
  border-radius: 20px;
  overflow: hidden;
}

.pk-roll-mode button {
  color: #fff;
  background: transparent;
  border: 0;
  font-size: 14px;
  font-weight: 1000;
}

.pk-roll-mode .active {
  background: #8569ff;
}

.pk-multiply-line,
.pk-balance-line {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pk-multiply-line {
  gap: 11px;
  color: #fff;
}

.pk-multiply-line span {
  color: #f4f6ff;
  font-size: 12px;
  line-height: 1.05;
  text-align: center;
  font-weight: 1000;
}

.pk-multiply-line button {
  width: 62px;
  height: 29px;
  color: #fff;
  background: #20232e;
  border: 2px solid #fff;
  border-radius: 18px;
  font-size: 13px;
  font-weight: 1000;
}

.pk-multiply-line .active {
  background: #8569ff;
}

.pk-balance-line {
  gap: 12px;
  margin-top: 54px;
}

.pk-balance-line span {
  color: #f4f6ff;
  font-size: 13px;
  line-height: 1.1;
  font-weight: 1000;
}

.pk-slider {
  width: 284px;
  height: 7px;
  position: relative;
  border-radius: 10px;
  background: #7664c9;
}

.pk-slider i {
  width: 21px;
  height: 21px;
  position: absolute;
  left: 0;
  top: 50%;
  background: #8a72ff;
  border-radius: 50%;
  transform: translateY(-50%);
}

.pk-balance-line strong {
  min-width: 48px;
  height: 23px;
  display: grid;
  place-items: center;
  color: #fff;
  background: #9d9d9d;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 1000;
}

.pk-upgrade-lists {
  margin-top: 0;
  display: grid;
  grid-template-columns: minmax(320px, 1fr) minmax(430px, 1fr);
  gap: 0;
}

.pk-inventory-column,
.pk-target-column {
  min-height: 550px;
  padding: 26px 18px 0;
  background: #171923;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.pk-inventory-column {
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.pk-inventory-column header,
.pk-target-column header {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.pk-inventory-column h2,
.pk-target-column h2 {
  margin: 0;
  color: #f4f6ff;
  font-size: 16px;
  font-weight: 1000;
}

.pk-inventory-column header button,
.pk-target-tools button {
  height: 34px;
  padding: 0 16px;
  color: #fff;
  background: #161924;
  border: 1px solid #4c5263;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 1000;
}

.pk-empty-inventory {
  height: 420px;
}

.pk-target-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pk-target-tools label {
  width: 150px;
  height: 34px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 9px;
  background: #121520;
  border: 1px solid #4c5263;
  border-radius: 5px;
}

.pk-target-tools label span {
  width: 15px;
  height: 15px;
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50%;
  position: relative;
}

.pk-target-tools label span::after {
  content: "";
  width: 8px;
  height: 2px;
  position: absolute;
  right: -6px;
  bottom: -3px;
  background: #fff;
  transform: rotate(45deg);
}

.pk-target-tools input {
  width: 82px;
  color: #fff;
  background: transparent;
  border: 0;
  outline: 0;
  font-size: 13px;
  font-weight: 1000;
}

.pk-target-tools button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.pk-target-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(4, minmax(124px, 1fr));
  gap: 10px;
}

.pk-upgrade-case-state {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8f98aa;
  font-size: 14px;
  font-weight: 900;
}

.pk-target-card {
  min-height: 217px;
  padding: 13px 12px 12px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  background:
    radial-gradient(circle at 50% 37%, rgba(104, 68, 255, 0.52), transparent 28%),
    #252837;
}

.pk-target-card.active {
  border-color: rgba(255, 189, 66, 0.78);
  box-shadow: inset 0 0 0 1px rgba(255, 189, 66, 0.22), 0 0 24px rgba(255, 139, 29, 0.12);
}

.pk-target-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(61, 177, 135, 0.08), rgba(163, 57, 105, 0.08));
  pointer-events: none;
}

.pk-target-card em {
  min-height: 16px;
  display: block;
  position: relative;
  z-index: 1;
  color: #ffd65f;
  font-size: 10px;
  line-height: 1.1;
  font-style: normal;
  font-weight: 1000;
}

.pk-card-visual {
  height: 116px;
  display: grid;
  place-items: center;
  position: relative;
  z-index: 1;
}

.pk-card-visual img {
  max-width: 116px;
  max-height: 96px;
  object-fit: contain;
  filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.42));
}

.pk-target-card strong {
  min-height: 34px;
  display: block;
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 12px;
  line-height: 1.25;
  font-weight: 1000;
}

.pk-target-card span {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
  z-index: 1;
  color: #ffcb3c;
  font-size: 13px;
  font-weight: 1000;
}

@media (max-width: 1280px) {
  .pk-case-upgrade-shell {
    padding: 0 20px;
  }

  .pk-upgrade-stage {
    grid-template-columns: 1fr;
  }

  .pk-stage-side--left::after,
  .pk-stage-side--right::after {
    display: none;
  }

  .pk-upgrade-controls {
    margin-left: 0;
    margin-right: 0;
  }

  .pk-upgrade-lists {
    grid-template-columns: 1fr;
  }

  .pk-target-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
}

@media (max-width: 760px) {
  .pk-case-upgrade-title {
    height: auto;
    padding: 22px 0;
  }

  .pk-title-left,
  .pk-target-column header,
  .pk-inventory-column header {
    align-items: flex-start;
    flex-direction: column;
  }

  .pk-stage-side {
    padding-left: 20px;
    padding-right: 20px;
  }

  .pk-upgrade-controls {
    padding-left: 14px;
    padding-right: 14px;
  }

  .pk-balance-line,
  .pk-multiply-line,
  .pk-target-tools {
    flex-wrap: wrap;
  }

  .pk-slider {
    width: 210px;
  }
}

/* 2026-07-05 exact-pass: case upgrade full-width target stage. */
.pk-case-upgrade-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  background:
    radial-gradient(ellipse at 52% 190px, rgba(255, 138, 31, 0.09), transparent 430px),
    linear-gradient(180deg, #20222f 0, #1c1d29 430px, #171923 100%) !important;
}

.pk-case-upgrade-shell {
  max-width: none !important;
  padding: 0 24px 94px !important;
}

.pk-case-upgrade-title {
  height: 72px !important;
  border-bottom: 1px solid #2b2d3c !important;
}

.pk-case-upgrade-title h1 {
  color: #f4ead8 !important;
  font-size: 24px !important;
  line-height: 72px !important;
}

.pk-case-upgrade-title button {
  height: 40px !important;
  color: #ecd8b8 !important;
  border: 1px solid rgba(236, 216, 184, 0.34) !important;
  background: #252837 !important;
}

.pk-upgrade-stage {
  min-height: 330px !important;
  margin-top: 18px !important;
  grid-template-columns: minmax(320px, 1fr) 340px minmax(320px, 1fr) !important;
  gap: 12px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 50% 66%, rgba(236, 216, 184, 0.08), transparent 58%),
    #20222f !important;
  box-shadow: none !important;
}

.pk-stage-side,
.pk-stage-center {
  min-height: 330px !important;
  border-color: rgba(67, 73, 96, 0.72) !important;
  background:
    radial-gradient(ellipse at 50% 54%, rgba(236, 216, 184, 0.055), transparent 64%),
    #252837 !important;
}

.pk-stage-side--left::after,
.pk-stage-side--right::after {
  opacity: 0.42 !important;
}

.pk-case-choice {
  width: 190px !important;
  height: 160px !important;
  border-radius: 8px !important;
  border: 1px dashed rgba(236, 216, 184, 0.32) !important;
  background:
    radial-gradient(circle, rgba(255, 138, 31, 0.08), transparent 62%),
    #20222f !important;
}

.pk-case-choice img {
  max-width: 178px !important;
  max-height: 136px !important;
}

.pk-upgrade-percent {
  width: 188px !important;
  height: 188px !important;
  border: 1px solid rgba(236, 216, 184, 0.28) !important;
  background:
    radial-gradient(circle, rgba(255, 138, 31, 0.18), transparent 62%),
    conic-gradient(from 0deg, rgba(255, 138, 31, 0.9), rgba(37, 210, 237, 0.75), rgba(67, 73, 96, 0.75), rgba(255, 138, 31, 0.9)) !important;
}

.pk-upgrade-percent strong {
  color: #fff7df !important;
}

.pk-upgrade-action {
  height: 46px !important;
  border-radius: 6px !important;
  color: #fff7df !important;
  background: linear-gradient(180deg, #ff971f, #f26b00) !important;
  box-shadow: 0 12px 24px rgba(242, 105, 0, 0.2) !important;
}

.pk-upgrade-controls {
  margin: 14px 0 0 !important;
  padding: 14px 16px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
}

.pk-upgrade-lists {
  margin-top: 14px !important;
  grid-template-columns: minmax(320px, 0.82fr) minmax(520px, 1.18fr) !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}

.pk-inventory-column,
.pk-target-column {
  min-height: 520px !important;
  background: #20222f !important;
}

.pk-target-grid {
  grid-template-columns: repeat(auto-fill, minmax(156px, 1fr)) !important;
  gap: 8px !important;
}

.pk-target-card {
  min-height: 204px !important;
  border: 1px solid rgba(67, 73, 96, 0.68) !important;
  background:
    radial-gradient(circle at 50% 37%, rgba(104, 68, 255, 0.34), transparent 36%),
    #252837 !important;
}

@media (max-width: 1280px) {
  .pk-upgrade-stage,
  .pk-upgrade-lists {
    grid-template-columns: 1fr !important;
  }
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  min-height: 320px !important;
  background:
    radial-gradient(circle at 50% 50%, rgba(76, 91, 224, 0.2), transparent 34%),
    #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-orbit {
  width: 285px !important;
  height: 285px !important;
  background:
    radial-gradient(circle, rgba(48, 61, 147, 0.44) 0 38%, rgba(57, 74, 178, 0.94) 39% 55%, rgba(35, 48, 133, 0.94) 56% 68%, transparent 69%) !important;
  box-shadow: 0 0 66px rgba(72, 94, 255, 0.42) !important;
  filter: none !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-ring {
  width: 210px !important;
  height: 210px !important;
  border: 0 !important;
  background:
    radial-gradient(circle, #303858 0 48%, transparent 49%),
    conic-gradient(#4c5fc2 0 100%) !important;
  box-shadow:
    inset 0 0 0 16px rgba(161, 172, 239, 0.21),
    inset 0 0 36px rgba(10, 15, 36, 0.6) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-ring strong {
  color: #fff7df !important;
}
</style>

<style lang="less">
/* Keep the 2026-07-21 target pass after older exact-pass overrides. */
.pk-case-upgrade-page.pk-account-panel {
  background: #21232f !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
  min-height: 320px !important;
  grid-template-columns: 350px minmax(600px, 1fr) 350px !important;
  gap: 0 !important;
  background: #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side,
.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  min-height: 320px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side {
  padding-top: 42px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--left::after,
.pk-case-upgrade-page.pk-account-panel .pk-stage-side--right::after {
  width: 0 !important;
  height: 336px !important;
  top: -8px !important;
  border-right: 2px solid #f5c758 !important;
  opacity: 1 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--left::after {
  right: 0 !important;
  transform: skewX(-18deg) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--right::after {
  left: 0 !important;
  transform: skewX(18deg) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  background:
    radial-gradient(circle at 50% 50%, rgba(76, 91, 224, 0.2), transparent 34%),
    #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-orbit {
  width: 285px !important;
  height: 285px !important;
  background:
    radial-gradient(circle, rgba(48, 61, 147, 0.44) 0 38%, rgba(57, 74, 178, 0.94) 39% 55%, rgba(35, 48, 133, 0.94) 56% 68%, transparent 69%) !important;
  box-shadow: 0 0 66px rgba(72, 94, 255, 0.42) !important;
  filter: none !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-ring {
  width: 210px !important;
  height: 210px !important;
  border: 0 !important;
  background:
    radial-gradient(circle, #303858 0 48%, transparent 49%),
    conic-gradient(#4c5fc2 0 100%) !important;
  box-shadow:
    inset 0 0 0 16px rgba(161, 172, 239, 0.21),
    inset 0 0 36px rgba(10, 15, 36, 0.6) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-controls {
  min-height: 306px !important;
  margin: 0 !important;
  padding: 56px 0 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
  width: auto !important;
  margin: 0 75px !important;
  grid-template-columns: minmax(420px, 1fr) minmax(520px, 1.07fr) !important;
  gap: 0 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-inventory-column,
.pk-case-upgrade-page.pk-account-panel .pk-target-column {
  min-height: 825px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-target-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
}

@media (max-width: 1450px) and (min-width: 1101px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
    grid-template-columns: 250px minmax(400px, 1fr) 250px !important;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings {
    margin-left: 0;
    margin-right: 0;
    grid-template-columns: 260px minmax(430px, 1fr) 260px;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media (max-width: 1100px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage,
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings,
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
    grid-template-columns: 1fr !important;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-comfort-figure {
    display: none;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>

<style lang="less">
/* 2026-07-21 target-pass: preserve the target 350 / center / 350 upgrade stage. */
.pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
  min-height: 320px !important;
  grid-template-columns: 350px minmax(600px, 1fr) 350px !important;
  gap: 0 !important;
  overflow: hidden !important;
  background: #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side,
.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  min-height: 320px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side {
  padding-top: 42px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--left::after,
.pk-case-upgrade-page.pk-account-panel .pk-stage-side--right::after {
  width: 0 !important;
  height: 336px !important;
  top: -8px !important;
  border-right: 2px solid #f5c758 !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 8px rgba(245, 199, 88, 0.16)) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--left::after {
  right: 0 !important;
  transform: skewX(-18deg) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--right::after {
  left: 0 !important;
  transform: skewX(18deg) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  background:
    radial-gradient(circle at 50% 50%, rgba(76, 91, 224, 0.2), transparent 34%),
    #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-orbit {
  width: 285px !important;
  height: 285px !important;
  background:
    radial-gradient(circle, rgba(48, 61, 147, 0.44) 0 38%, rgba(57, 74, 178, 0.94) 39% 55%, rgba(35, 48, 133, 0.94) 56% 68%, transparent 69%) !important;
  box-shadow: 0 0 66px rgba(72, 94, 255, 0.42) !important;
  filter: none !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-ring {
  width: 210px !important;
  height: 210px !important;
  border: 0 !important;
  background:
    radial-gradient(circle, #303858 0 48%, transparent 49%),
    conic-gradient(#4c5fc2 0 100%) !important;
  box-shadow:
    inset 0 0 0 16px rgba(161, 172, 239, 0.21),
    inset 0 0 36px rgba(10, 15, 36, 0.6) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-ring strong {
  color: #e8ebf6 !important;
  font-size: 34px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-price-tag {
  width: 132px !important;
  height: 55px !important;
  bottom: 19px !important;
  padding-top: 7px !important;
  background: #f7cb5a !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings {
  min-height: 306px;
  margin: 10px 75px 0;
  display: grid;
  grid-template-columns: 400px minmax(520px, 675px) 400px;
  justify-content: space-between;
  overflow: hidden;
  background: #171924;
}

.pk-case-upgrade-page.pk-account-panel .pk-comfort-figure {
  height: 306px;
  background-repeat: no-repeat;
  background-size: 1920px 1080px;
  animation: pk-upgrade-comfort-float 4.6s ease-in-out infinite;
}

.pk-case-upgrade-page.pk-account-panel .pk-comfort-figure--good {
  background-position: -345px -669px;
}

.pk-case-upgrade-page.pk-account-panel .pk-comfort-figure--bad {
  background-position: -1420px -669px;
  animation-delay: -2.3s;
}

@keyframes pk-upgrade-comfort-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-controls {
  min-height: 306px !important;
  margin: 0 !important;
  padding: 56px 0 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-roll-mode {
  width: 294px !important;
  height: 33px !important;
  margin-bottom: 38px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-multiply-line button {
  width: 89px !important;
  height: 32px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-balance-line {
  margin-top: 46px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-slider {
  width: 310px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
  width: auto !important;
  margin: 0 75px !important;
  grid-template-columns: minmax(420px, 1fr) minmax(520px, 1.07fr) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-inventory-column,
.pk-case-upgrade-page.pk-account-panel .pk-target-column {
  min-height: 825px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-target-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
}

@media (max-width: 1450px) and (min-width: 1101px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
    grid-template-columns: 250px minmax(400px, 1fr) 250px !important;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings {
    margin-left: 0;
    margin-right: 0;
    grid-template-columns: 260px minmax(430px, 1fr) 260px;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media (max-width: 1100px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage,
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings,
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
    grid-template-columns: 1fr !important;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-comfort-figure {
    display: none;
  }

  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: case upgrade mode surface and item density. */
.pk-case-upgrade-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 18px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 210px, rgba(76, 91, 224, 0.12), transparent 460px),
    #21232f !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage,
.pk-case-upgrade-page.pk-account-panel .pk-upgrade-controls,
.pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
  width: 100% !important;
  max-width: none !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
  min-height: 320px !important;
  gap: 0 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side,
.pk-case-upgrade-page.pk-account-panel .pk-stage-center,
.pk-case-upgrade-page.pk-account-panel .pk-stage-core,
.pk-case-upgrade-page.pk-account-panel .pk-upgrade-controls,
.pk-case-upgrade-page.pk-account-panel .pk-inventory-column,
.pk-case-upgrade-page.pk-account-panel .pk-target-column {
  border-color: transparent !important;
  border-radius: 0 !important;
  background: #212436 !important;
  box-shadow: none !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-core,
.pk-case-upgrade-page.pk-account-panel .pk-stage-center {
  background:
    radial-gradient(circle at 50% 50%, rgba(76, 91, 224, 0.2), transparent 34%),
    #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-case-choice {
  width: 204px !important;
  height: 164px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
  margin-top: 8px !important;
  grid-template-columns: minmax(330px, 0.78fr) minmax(560px, 1.22fr) !important;
  gap: 0 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-target-grid {
  grid-template-columns: repeat(auto-fill, minmax(148px, 1fr)) !important;
  gap: 8px !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-target-card {
  min-height: 194px !important;
  border-radius: 7px !important;
}
</style>

<style lang="less" scoped>
/* Final target-stage precedence over historical desktop overrides. */
.pk-case-upgrade-page.pk-account-panel { background: #21232f !important; }

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings { height: 306px; }

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
  min-height: 320px !important;
  grid-template-columns: 350px minmax(600px, 1fr) 350px !important;
  gap: 0 !important;
  background: #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side,
.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  min-height: 320px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side { padding-top: 42px !important; }

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--left::after,
.pk-case-upgrade-page.pk-account-panel .pk-stage-side--right::after {
  width: 0 !important;
  height: 336px !important;
  top: -8px !important;
  border-right: 2px solid #f5c758 !important;
  opacity: 1 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--left::after {
  right: 0 !important;
  transform: skewX(-18deg) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-side--right::after {
  left: 0 !important;
  transform: skewX(18deg) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-stage-core {
  background:
    radial-gradient(circle at 50% 50%, rgba(76, 91, 224, 0.2), transparent 34%),
    #212436 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-orbit {
  width: 285px !important;
  height: 285px !important;
  background:
    radial-gradient(circle, rgba(48, 61, 147, 0.44) 0 38%, rgba(57, 74, 178, 0.94) 39% 55%, rgba(35, 48, 133, 0.94) 56% 68%, transparent 69%) !important;
  box-shadow: 0 0 66px rgba(72, 94, 255, 0.42) !important;
  filter: none !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-chance-ring {
  width: 210px !important;
  height: 210px !important;
  border: 0 !important;
  background:
    radial-gradient(circle, #303858 0 48%, transparent 49%),
    conic-gradient(#4c5fc2 0 100%) !important;
  box-shadow:
    inset 0 0 0 16px rgba(161, 172, 239, 0.21),
    inset 0 0 36px rgba(10, 15, 36, 0.6) !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-controls {
  height: 306px !important;
  min-height: 306px !important;
  margin: 0 !important;
  padding: 56px 0 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists {
  width: auto !important;
  margin: 0 75px !important;
  grid-template-columns: minmax(420px, 1fr) minmax(520px, 1.07fr) !important;
  gap: 0 !important;
}

.pk-case-upgrade-page.pk-account-panel .pk-inventory-column,
.pk-case-upgrade-page.pk-account-panel .pk-target-column { min-height: 825px !important; }

.pk-case-upgrade-page.pk-account-panel .pk-target-grid { grid-template-columns: repeat(5, minmax(0, 1fr)) !important; }

@media (max-width: 1450px) and (min-width: 1101px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage { grid-template-columns: 250px minmax(400px, 1fr) 250px !important; }
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings {
    margin-left: 0;
    margin-right: 0;
    grid-template-columns: 260px minmax(430px, 1fr) 260px;
  }
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists { margin-left: 0 !important; margin-right: 0 !important; }
}

@media (max-width: 1100px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage,
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-settings,
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists { grid-template-columns: 1fr !important; }
  .pk-case-upgrade-page.pk-account-panel .pk-comfort-figure { display: none; }
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-lists { margin-left: 0 !important; margin-right: 0 !important; }
}

@media (min-width: 1101px) {
  .pk-case-upgrade-page.pk-account-panel .pk-upgrade-stage {
    height: 320px !important;
    grid-template-columns: minmax(0, 1fr) 420px minmax(0, 1fr) !important;
  }
}
</style>
